import { render, staticRenderFns } from "./PatternSettings.vue?vue&type=template&id=22b2d032&scoped=true&"
import script from "./PatternSettings.vue?vue&type=script&lang=ts&"
export * from "./PatternSettings.vue?vue&type=script&lang=ts&"
import style0 from "./PatternSettings.vue?vue&type=style&index=0&id=22b2d032&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b2d032",
  null
  
)

export default component.exports